import EditorPublishButton from 'ContentEditorUI/components/shared/EditorPublishButton';
import { getCannotPublishOnActiveDomainReason, getIsPublishEnabled, getIsUnpublishEnabled, getPublishButtonTextKey, getLockedPublishButtonTextKey, getPagesTypeHasSavedViews
// @ts-expect-error Untyped module
} from '../redux/selectors/pagePublishSelectors';
import { useSelector } from 'react-redux';
import { getPageErrorLabels, getPageWarningLabels
// @ts-expect-error Untyped module
} from '../redux/selectors/pageWarningsAndSuggestionsSelectors';
// @ts-expect-error Untyped module
import { getCanSchedule } from '../redux/selectors/authSelectors';
import { getAbMasterName, getIsABVariant } from 'ContentEditorUI/redux/selectors/abTestSelectors';
import { getIsMABExperiment, getIsMabVariant, getMABExperimentIsStarted, getMABExperimentPrimayVariantName
// @ts-expect-error Untyped module
} from 'ContentEditorUI/redux/selectors/mabExperimentSelectors';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Untyped module
import { updateFocusedItem } from 'page-editor-ui/redux/actions/pageFocusActions';
import { useMemo, useState } from 'react';
import AudienceAccessTypes from 'ContentUtils/constants/AudienceAccessTypes';
import useAudienceAccessType from '../hooks/useAudienceAccessType';
import { getIsBlogListingPage } from 'ContentEditorUI/redux/selectors/contentReadOnlyDataSelectors';
import { getHasContentTypeLimitReducerAndExceededLimit } from 'ContentEditorUI/redux/selectors/limitSelectors';
// @ts-expect-error Untyped module
import { getHasStagingDomain } from 'ContentEditorUI/redux/selectors/contentSchemaSelectors';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { getIsReadOnlyMode } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
// @ts-expect-error Untyped module
import { getDashboardUrl } from '../redux/selectors/urlSelectors';
// @ts-expect-error Untyped module
import { getHasExceededMlangPagesLimit } from '../redux/selectors/pageLimitSelectors';
// @ts-expect-error Untyped module
import MABPublishConfirmModal from 'ContentEditorUI/components/publishing/modals/MABPublishConfirmModal';
// @ts-expect-error Untyped module
import { getPageUsageLimitExceededLockedPulishButtonUpgradeModalKey } from '../redux/selectors/downgradeSelectors';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import I18n from 'I18n';
// @ts-expect-error Untyped module
import { getPublishNoun } from 'ContentEditorUI/redux/selectors/publishSelectors';
import ContentRoutes from 'ContentUtils/Routes';
// @ts-expect-error Untyped module
import { getContextActiveDomainAsMap } from 'ContentEditorUI/redux/selectors/contentSchemaSelectors';
import PatagoniaPagePublishConfirmModal from '../components/PatagoniaPagePublishConfirmModal';
import { usePublishLifecycleHandlers } from '../hooks/usePublishAction';
import usePublishActionHandlers from 'ContentEditorUI/components/publishing/hooks/usePublishActionHandlers';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PagePublishButtonContainer = () => {
  const cannotPublishOnDomainReason = useSelector(getCannotPublishOnActiveDomainReason);
  const errors = useSelector(getPageErrorLabels);
  const warnings = useSelector(getPageWarningLabels);
  const canSchedule = useSelector(getCanSchedule);
  const publishEnabled = useSelector(getIsPublishEnabled);
  const unpublishEnabled = useSelector(getIsUnpublishEnabled);
  const isAbVariant = useSelector(getIsABVariant);
  const isMabVariant = useSelector(getIsMabVariant);
  const abPrimaryName = useSelector(getAbMasterName);
  const mabPrimaryName = useSelector(getMABExperimentPrimayVariantName);
  const isMABExperiment = useSelector(getIsMABExperiment);
  const mabExperimentIsStarted = useSelector(getMABExperimentIsStarted);
  const buttonTextKey = useSelector(getPublishButtonTextKey);
  const lockedButtonTextKey = useSelector(getLockedPublishButtonTextKey);
  const isReadOnlyMode = useSelector(getIsReadOnlyMode);
  const controlCenterUrl = useSelector(getDashboardUrl);
  const hasExceededMlangSitePagesLimit = useSelector(getHasExceededMlangPagesLimit);
  const tooltipOverride = useMemo(() => {
    if (hasExceededMlangSitePagesLimit) {
      return /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "mLang.sitePageLimitExceededError",
        options: {
          controlCenterUrl
        }
      });
    } else if (isReadOnlyMode) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: 'app.readOnly.publishButton.pages'
      });
    }
    return;
  }, [controlCenterUrl, hasExceededMlangSitePagesLimit, isReadOnlyMode]);
  const [mabConfirmModalOpen, setMabConfirmModalOpen] = useState(false);
  const audienceAccessType = useAudienceAccessType();
  const isBlogListingPage = useSelector(getIsBlogListingPage);
  const hasExceededContentTypeLimit = useSelector(getHasContentTypeLimitReducerAndExceededLimit);
  const hasStagingDomain = useSelector(getHasStagingDomain);
  const upgradeModalKey = useSelector(getPageUsageLimitExceededLockedPulishButtonUpgradeModalKey);
  const {
    openUpgradeModal
  } = useUpgradeModal(upgradeModalKey);
  const contextActiveDomain = useSelector(getContextActiveDomainAsMap);
  const publishNoun = useSelector(getPublishNoun);
  const contentTypeHasSavedViews = useSelector(getPagesTypeHasSavedViews);
  if (cannotPublishOnDomainReason) {
    errors.push({
      message: `publishingOptions.baymaxNotAuthorizedReasons.${cannotPublishOnDomainReason}`,
      options: {
        domain: contextActiveDomain.get('domain'),
        noun: I18n.text(publishNoun),
        domainManagerUrl: ContentRoutes.domainManager(),
        knowledgeArticleUrl: 'https://knowledge.hubspot.com/articles/kcs_article/cos-general/connect-a-domain-to-hubspot'
      },
      useHtml: true
    });
  }
  const publishLifecycleHandlers = usePublishLifecycleHandlers();
  const {
    publish,
    unpublish
  } = usePublishActionHandlers(publishLifecycleHandlers);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(EditorPublishButton, {
      cannotPublishOnDomainReason: cannotPublishOnDomainReason,
      errors: errors,
      warnings: warnings,
      canSchedule: canSchedule && !isBlogListingPage && !hasExceededContentTypeLimit && !hasStagingDomain,
      publishEnabled: publishEnabled,
      unpublishEnabled: unpublishEnabled,
      testVariationTooltipPropsForApproval: {
        isTestVariation: isAbVariant || isMabVariant,
        testVariationDisabledTooltip: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "approvals.testVariationRequestApprovalDisabledTooltip",
          options: {
            name: abPrimaryName || mabPrimaryName
          }
        })
      },
      buttonTextKey: hasExceededContentTypeLimit ? lockedButtonTextKey : buttonTextKey,
      updateFocusedItemAction: updateFocusedItem,
      tooltipOverride: tooltipOverride,
      isLocked: hasExceededContentTypeLimit,
      onClickLocked: openUpgradeModal,
      schedulingOptionsModalProps: {
        dashboardUrl: controlCenterUrl,
        allowBackdating: false,
        canScheduleUnpublish: true
      },
      contentTypeHasSavedViews: contentTypeHasSavedViews,
      shouldConfirmPublishAction: audienceAccessType !== AudienceAccessTypes.ALL,
      publishConfirmModalBodyContent: /*#__PURE__*/_jsx(PatagoniaPagePublishConfirmModal, {}),
      shouldUseCustomPublishHandler: isMABExperiment && !mabExperimentIsStarted,
      customPublishHandler: () => setMabConfirmModalOpen(true),
      publish: publish,
      unpublish: unpublish
    }), mabConfirmModalOpen && /*#__PURE__*/_jsx(MABPublishConfirmModal, {
      dismissCallback: () => setMabConfirmModalOpen(false)
    })]
  });
};
export default PagePublishButtonContainer;